const routePermissions = [
    {
        modules: 'Dashboard',
        module_path: 'APDashBoard',
        permissions: [{ show: true }]
    },
    {
        modules: 'Students',
        module_path: 'APStudents',
        permissions: [{
            show: false,
            enquiry: false,
            book_free_assesment: false,
            add_to_joined: false,
            enquiry_delete: false,
            joined: false,
            joined_view: false,
            joined_edit: false,
            joined_delete: false,
        }]
    },
    {
        modules: 'Tutors',
        module_path: 'Tutors',
        permissions: [{ show: false, t_add: false, t_view: false, t_edit: false, t_delete: false }]
    },
    {
        modules: 'Tutor Sessions',
        module_path: 'TutorSessions',
        permissions: [{
            show: false,
        }]
    },
    {
        modules: 'Student Attendance',
        module_path: 'Attendance',
        permissions: [{ show: false }]
    },
    {
        modules: 'Teacher Attendance',
        module_path: 'TeacherAttendance',
        permissions: [{ show: false }]
    },
    {
        modules: 'Record Management',
        module_path: 'RecordManagement',
        permissions: [{ show: false, joinedStudents: false, joinedTutors: false, receiveCallData: false, tutorCV: false, r_edit: false, r_delete: false }]
    },
    {
        modules: 'Groups',
        module_path: 'Groups',
        permissions: [{ show: false, g_add: false, g_edit: false, g_delete: false }]
    },
    {
        modules: 'CatchUp',
        module_path: 'CatchUps',
        permissions: [{ show: false, catchups: false, requests: false, absents: false, complete: false }]
    },
    {
        modules: 'Work',
        module_path: 'Works',
        permissions: [{ show: false, work_add: false, work_edit: false, work_delete: false }]
    },
    {
        modules: 'Accounts',
        module_path: 'Accounts',
        permissions: [{
            show: false,  // view invoice
            // Payment 
            payment: false,   // done
            pay_add: false, // add invoice button
            pay_view: false,  // view invoice
            pay_sendInvoice: false, // for payment tab send invoice done
            pay_status: false, // update status
            pay_remove: false, // remove invoice

            // static (Thu Sep 1, 3:19 PM)

            // earning
            earning: false,
            earn_view: false,  // view invoice

            // bad dept
            badDept: false,
            // badDept_edit: false, 
            // badDept_delete: false,

            // tutor earning
            tutorEarning: false,
            tutor_earn_add: false,
            tutor_earn_edit: false,
            tutor_earn_delete: false,
        }]
    },
    {
        modules: 'Work Sheet',
        module_path: 'WorkSheet',
        permissions: [{ show: false, upload: false, assign: false, print: false, chartView: false, answerSheet: false }]
    },
    {
        modules: 'Settings',
        module_path: 'Settings',
        permissions: [{ show: false, classes: false, users: false, discounts: false, configrations: false, roles: false, permissions: false }]
    },
    {
        modules: 'Reports',
        module_path: 'Reports',
        permissions: [{ show: false, attendance: false }]
    },
    {
        modules: 'Student Profile',
        module_path: 'StudentProfileSP',
        permissions: [{ show: false }]
    },
    {
        modules: 'Student Classes',
        module_path: 'SPStudentClasses',
        permissions: [{ show: false, upComingClasses: false, completedClasses: false }]
    },
    {
        modules: 'Student CatchUp',
        module_path: 'StudentCatchUp',
        permissions: [{ show: false }]
    },
    {
        modules: 'Student Accounts',
        module_path: 'StudentAccounts',
        permissions: [{ show: false, paid: false, unPain: false }]
    },
    {
        modules: 'Upload Work',
        module_path: 'Upload',
        permissions: [{ show: false, uploadedWork: false, previousWork: false }]
    },
    {
        modules: 'Work Sheet',
        module_path: 'StudentWorkSheet',
        permissions: [{ show: false, view: false }]
    },
    {
        modules: 'Admission Form',
        module_path: 'AdmissionForm',
        permissions: [{ show: false }]
    },
    {
        modules: 'Tutor Profile',
        module_path: 'TPTutorProfile',
        permissions: [{ show: false }]
    },
    {
        modules: 'Tutor Classes',
        module_path: 'TutorClasses',
        permissions: [{ show: false, upComingClasses: false, completedClasses: false }]
    },
    {
        modules: 'Tutor Accounts',
        module_path: 'TutorAccounts',
        permissions: [{ show: false, pending: false, cleared: false }]
    },
    // {
    //     modules: 'Tutor WorkSheet',
    //     module_path: 'TutorWorkSheet',
    //     permissions: [{ show: false, view: false, delete: false }]
    // },
    {
        modules: 'Tutor Uploaded',
        module_path: 'TutorUploadedWork',
        permissions: [{ show: false }]
    },
]

export default routePermissions;